import React from "react";

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="flex justify-center pt-32 min-h-screen bg-white font-sans text-left">
      <div className="container mx-auto w-[90%] lg:w-[70%]">
        {/* Header */}
        {/* <ScrollReveal delay={0.1}> */}
          <div className="text-center mb-16 mx-auto">
          <p
            className="text-heading-large bg-gradient-to-r
         from-[#e20016] from-[0%]
         via-[#712f59] via-[40%]
         to-[#005d9c] to-[100%] bg-clip-text text-transparent font-bold font-open-sans-hebrew py-2"
          >
                Privacy Policy
          </p>
          <p className="text-gray-500 max-w-lg mx-auto text-body font-raleway">
            Discover expert insights, product guidance, and industry updates to
            help you make informed decisions for every project.
            </p>
        </div>
        {/* </ScrollReveal> */}

        {/* Hero Image */}
        {/* <ScrollReveal delay={0.15}> */}
          <div className="w-full h-[300px] md:h-[500px] rounded-[32px] overflow-hidden mb-20">
            <img 
                src="https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?q=80&w=2400&auto=format&fit=crop" 
                alt="Plywood Sheets" 
                className="w-full h-full object-cover"
            />
        </div>
        {/* </ScrollReveal> */}

        {/* Content Sections */}
        {/* <ScrollReveal delay={0.2}> */}
          <div className="max-w-5xl mx-auto space-y-16 mb-32">
            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              1. Information We Collect
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              We Collect Personal Information That You Voluntarily Provide When
              Submitting Enquiries, Filling Out Contact Forms, Or Interacting
              With Our Website. This May Include Your Name, Phone Number, Email
              Address, Company Details, And Project Information. If You Choose
              To Register Or Subscribe, We May Also Store Additional Optional
              Details You Submit. All Information Collected Helps Us Respond To
              Your Requests, Provide Accurate Product Guidance, And Improve Your
              Overall Experience With Our Services.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              2. Usage Data Tracking
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              When You Browse Our Website, Certain Technical Data Is
              Automatically Recorded To Help Us Understand User Behaviour And
              Improve Platform Performance. This May Include IP Address, Device
              Type, Browser Version, Time Spent On Specific Pages, And
              Interaction Patterns Such As Clicks, Scroll Behaviour, Or Page
              Navigation. This Information Does Not Personally Identify You But
              Helps Us Analyse Traffic, Optimize Content, Troubleshoot Issues,
              And Create A Smoother, More Efficient Browsing Experience For All
              Visitors.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              3. Cookies And Tracking Technologies
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              Our Website Uses Cookies And Similar Tracking Technologies To
              Enhance Your Browsing Experience. Cookies Help Remember
              Preferences, Personalize Content, Track Page Performance, And
              Collect Analytics For Site Improvement. We May Use Third-Party
              Tools Like Google Analytics For Understanding Visitor Trends. You
              Can Accept, Reject, Or Delete Cookies Through Your Browser
              Settings At Any Time. Disabling Certain Cookies May Limit Some
              Website Features But Will Not Affect Your Ability To Browse
              Essential Pages.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              4. How We Use Your Information
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              We Use The Information We Collect To Deliver Our Services
              Efficiently, Respond To Enquiries, Provide Product
              Recommendations, And Offer Customer Support. Your Data May Also
              Help Us Enhance Website Functionality, Improve Communication,
              Personalize Content, And Keep You Updated About New Products Or
              Service Announcements. We Ensure That All Information Is Used
              Responsibly And Only For Legitimate Business Purposes That Improve
              Your Experience And Strengthen Your Relationship With Our Brand.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              5. Sharing And Disclosure
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              We Do Not Sell Or Trade Your Personal Information. In Certain
              Cases, We May Share Data With Trusted Partners Who Assist Us In
              Website Maintenance, Analytics, Hosting, Communication, Or
              Customer Service. These Partners Are Required To Protect Your Data
              In Alignment With Our Privacy Standards. Personal Data May Also Be
              Shared When Required By Law, Governmental Authorities, Or To
              Protect Our Rights, Users, Or Infrastructure From Fraud Or
              Security Threats.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              6. Data Security Practices
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              We Prioritize The Security Of Your Information And Implement
              Industry-Standard Measures To Protect It. This Includes Secure
              Servers, Encrypted Communication Channels, Controlled Access, And
              Ongoing Monitoring To Prevent Unauthorized Use, Disclosure, Or
              Loss. While No System Is Completely Immune To Security Risks, We
              Take All Reasonable Steps To Safeguard Your Data And Ensure That
              It Remains Protected Throughout Its Lifecycle Within Our
              Organization's Digital Environment And Operational Processes.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              7. Third-Party Services
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              Our Website May Contain Links, Integrations, Or Embedded Tools
              From Third-Party Platforms Such As Google, Facebook, WhatsApp, Or
              Analytics Providers. These External Sites May Collect Data Based
              On Their Own Privacy Policies, And We Do Not Control Or Take
              Responsibility For How They Handle Your Information. We Encourage
              Users To Review The Privacy Policies Of Any Third-Party Service
              They Interact With To Understand How Their Data May Be Collected,
              Stored, Or Used.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              8. Your Rights And Choices
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              You Have Full Control Over Your Personal Information And May
              Request Access, Correction, Updates, Or Deletion At Any Time. You
              Can Also Object To Certain Types Of Data Processing Or Choose To
              Unsubscribe From Marketing Communications. We Will Always Respect
              And Comply With Your Choices In Accordance With Applicable
              Regulations. To Exercise Your Rights, Simply Contact Us Through
              The Official Details Provided On Our Website, And Our Team Will
              Assist Promptly.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              9. Data Retention
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              We Retain Personal Information Only For As Long As Necessary To
              Provide Our Services, Respond To Enquiries, Meet Legal
              Requirements, And Maintain Essential Business Records. Once The
              Retention Period Expires, Data Is Securely Deleted Or Anonymized
              To Ensure Privacy. The Duration May Vary Depending On The Nature
              Of The Interaction, Project Timelines, And Regulatory Guidelines.
              We Ensure That All Stored Data Is Regularly Reviewed, Protected,
              And Managed Responsibly Throughout Its Lifecycle.
                </p>
            </section>

            <section>
            <h2 className="text-heading-section font-bold text-black mb-6 font-open-sans-hebrew">
              10. Contact For Privacy Queries
            </h2>
            <p className="text-gray-600 text-body font-raleway">
              If You Have Questions About How Your Data Is Collected, Used, Or
              Protected, You Can Contact Us Anytime Using The Email Or Phone
              Details Listed On Our Website. Our Team Will Assist With
              Privacy-Related Concerns, Data Access Requests, Or Clarifications
              Regarding This Policy. We Are Committed To Transparency And
              Maintaining The Trust Of Every Visitor, Ensuring Clear
              Communication And Responsible Handling Of Personal Information In
              Accordance With Industry Standards.
                </p>
            </section>
        </div>
        {/* </ScrollReveal> */}
      </div>
    </div>
  );
};
